<template> 
  <main-block> 
    <create-simulation/>
  </main-block>
</template>

<script> 
import {mapActions, mapGetters} from 'vuex';
import Vue from 'vue';
import CreateSimulation from '@/components/forms/CreateSimulation';

export default {
  name: 'Home', 
  components: {
    CreateSimulation
  }, 
}
</script>
